import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfoModalComponent } from '../modals/info-modal/info-modal.component';
import { ConfirmSentComponent } from '../modals/confirm-sent/confirm-sent.component';
import { exit } from 'process';

@Component({
  selector: 'app-social-login',
  templateUrl: './social-login.component.html',
  styleUrls: ['./social-login.component.scss']
})
export class SocialLoginComponent implements OnInit {

  public isLoading = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private loginService: LoginService,
    private router: Router,
    private translate: TranslateService) { }

  ngOnInit() {

    const language = this.translate.currentLang;

    this.activatedRoute.queryParamMap.subscribe(map => {
      const token = decodeURIComponent(map.get('thirdPartyProviderToken'));
      const error = map.get('error');

      if (token) {

        localStorage.setItem('new_user', JSON.stringify(true));

        if (localStorage.getItem('profile-settings')) {
          const confirm = this.modalService.open(ConfirmSentComponent);
          confirm.componentInstance.data = {
            text: 'Are you sure you want to link your social account',
            header: 'Link your social account'
          };
          confirm.result.then(ok => {
            this.loginService.linkSocialAccounts(token).subscribe(res => {
              const infoDlg = this.modalService.open(InfoModalComponent);
              infoDlg.componentInstance.data = {
                text: "Social Account is linked successfully",
                header: 'Success'
              };
              infoDlg.result.then(() => this.router.navigate(['settings/profile']));
            },
              err => {
                const infoDlg = this.modalService.open(InfoModalComponent);
                infoDlg.componentInstance.data = {
                  text: err,
                  header: 'Failure'
                };
                infoDlg.result.then(() => this.router.navigate(['settings/profile']));
              });
          },
            exit => {
              this.router.navigate(['/login']);
            });
        }
        else {
          this.loginService.thirdPartyLogin(token).pipe(tap(r => {
            return this.loginService
              .getMyInfo(r['accessToken'])
              .subscribe(res => {
                localStorage.setItem('user_id', JSON.stringify(res.userId.id));
                this.router.navigate(['/', 'help']);
              },
                err => {
                  const errorObj = err.error;
                  let errorMessage = '';
                  if (errorObj.status === 500) {
                    errorMessage = 'An unexpected error has occurfed. Please try again later. If the error keeps occurring, please contact our support team.';
                  } else {
                    errorMessage = errorObj.error
                  }
                  const infoDlg = this.modalService.open(InfoModalComponent);
                  infoDlg.componentInstance.data = {
                    text: errorMessage,
                    header: 'Failure!'
                  };
                  const currentLang = localStorage.getItem('user_lng')
                  localStorage.clear();
                  localStorage.setItem('user_lng',currentLang)
                  this.router.navigate(['/login']);
                }
              );
          })).subscribe(
            res => { },
            err => {
              const errorObj = err.error;
              let errorMessage = '';
              if (errorObj.status === 500) {
                errorMessage = 'An unexpected error has occurfed. Please try again later. If the error keeps occurring, please contact our support team.';
              } else {
                errorMessage = errorObj.error
              }
              const infoDlg = this.modalService.open(InfoModalComponent);
              infoDlg.componentInstance.data = {
                text: errorMessage,
                header: 'Failure'
              };
              infoDlg.result.then(() => {
                const currentLang = localStorage.getItem('user_lng')
                localStorage.clear();
                localStorage.setItem('user_lng',currentLang)
                this.router.navigate(['/login'])
              });
            }
          );
        }
      }
      else {
        this.router.navigate(['/login']);
      }
    });
  }
}
